/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarInfo } from '../../models/calendar-info';

export interface GetUserCalendarDelegates$Plain$Params {
}

export function getUserCalendarDelegates$Plain(http: HttpClient, rootUrl: string, params?: GetUserCalendarDelegates$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CalendarInfo>>> {
  const rb = new RequestBuilder(rootUrl, getUserCalendarDelegates$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CalendarInfo>>;
    })
  );
}

getUserCalendarDelegates$Plain.PATH = '/api/User/Calendar/delegated';
